// extracted by mini-css-extract-plugin
module.exports = {"accordion":"Accordion_accordion__1xUp5","toggle":"Accordion_toggle__3BK4w","details":"Accordion_details__37jJI"};